import { render, staticRenderFns } from "./ShippingsSettingsTemplate.vue?vue&type=template&id=044d7b76"
import script from "./ShippingsSettingsTemplate.vue?vue&type=script&lang=js"
export * from "./ShippingsSettingsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports